import { render, staticRenderFns } from "./AdditionalFieldsModal.vue?vue&type=template&id=705080b6&"
import script from "./AdditionalFieldsModal.vue?vue&type=script&lang=js&"
export * from "./AdditionalFieldsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports